import { useEffect, useState } from "react"
import moment from "moment";
import { ProjectDashScreen } from "../../screen/ProjectDashScreen"
import { useScope } from "../SelectProjectCompanyContainer";
import Send from "../../core/communication";
import { customToast } from "../../components/Toast";

const sectorsIndicators = [
  { id: 'Transformacao', label: 'Transformação digital', goal: '< 10' }, // < 10%
  { id: 'Educacao', label: 'Educação', goal: '> 90' }, // > 90%
  { id: 'Assistencia', label: 'Assistência técnica', goal: '> 70' }, // > 70%
  { id: 'Desconexao', label: 'Desconectados', goal: '< 20' } // < 20%
];

const assistanceIndicators = [
  { id: 'Nota0', label: 'Produtores com nota 0', goal: '< 10' }, // < 10%
  { id: 'Nota1', label: 'Produtores com nota 1', goal: '< 10' }, // < 10%
  { id: 'Nota2', label: 'Produtores com nota 2', goal: '< 10' }, // < 10%
  { id: 'Nota3', label: 'Produtores com nota 3', goal: '< 10' }, // < 10%
  { id: 'Nota4', label: 'Produtores com nota 4', goal: '< 10' }, // < 10%
  { id: 'Nota5', label: 'Produtores com nota 5', goal: '< 10' }, // < 10%
  { id: 'ConteudosEnviados', label: 'Conteúdos enviados', goal: null }, // > 90%
];

const sortDw = dw => dw.sort((dw1, dw2) => dw1.date - dw2.date);

const hasGoalAchived = ([calcType, goal], value) => {
  switch(calcType) {
    case '<':
      return value < goal;
      break;
    case '>':
      return value > goal;
      break;
  }
}

const formattDw = (dw = [], indicators = []) => {
  if(!dw || dw.length === 0) {
    return [];
  }

  const sortedDw = sortDw(dw);
  const formattedIndicators = indicators.map( indicator => {
    const percentValue = sortedDw[sortedDw.length - 1] && sortedDw[sortedDw.length - 1][`Indice${indicator?.id}`] || 0;
    const value = sortedDw[sortedDw.length - 1][`${indicator.id}`];
    const goalAchieved = indicator.goal ? hasGoalAchived(indicator.goal.split(' '), percentValue) : null;

    return {
      ...indicator,
      goalAchieved,
      value,
      percent: indicator.goal !== null ? percentValue : null,
      totalProducers: sortedDw[sortedDw.length - 1].NumProdutores
    };
  })

  return formattedIndicators;
}
 
export const ProjectDashContainer = () => {
  const { scope } = useScope();
  const [dw, setDw] = useState([]);

  useEffect(() => {
    if(scope?.id) {
      Send.get(`/DW/kpi/${scope?.id}`, `projectId='${scope?.id}'`)
      .then(result => {
        if(result.message) {
          throw new Error(result.message);
        }
        setDw(result.map(item => ({...item, date: moment(`${item?.year}-${item.month}-${item.day}`)})));
      })
      .catch(error => customToast(`Erro ao buscar indicadores: ${error}`, 'error'));
    }
  }, [scope?.id]);

  return <ProjectDashScreen
    {...{dw}}
    formattDw={formattDw(dw, sectorsIndicators)}
    assistanceDw={formattDw(dw, assistanceIndicators)}
  />
}

export default ProjectDashContainer